import client from "@/utils/api/client";

export const approveJoinTeam = async (teamId: number, token: string) => {
  return client.teamsIdApproveJoinPost({
    id: teamId,
    oneTimeTokenParameter: { token },
  });
};
